import React from 'react';

// Material UI
import MuiTableRow from "@mui/material/TableRow";
import {styled} from "@mui/material/styles";

// Assets
import {black500, greyishBlue100} from "assets/jss/main";

const StyledTableRow= styled(MuiTableRow,{
    shouldForwardProp: (prop) => !['isDesktop'].includes(prop), // Empêche la transmission de ces props` au DOM
})(({ theme, isDesktop }) => ({
    'td:first-of-type': {
        border: `1px solid ${greyishBlue100}`,
        borderWidth: '1px 0px 1px 1px',
        borderRadius: '8px 0 0 8px',
        paddingTop: '12px',
        paddingBottom: '12px',
        paddingLeft: isDesktop ? '12px': '16px',
    },
    'td:last-child': {
        border: `1px solid ${greyishBlue100}`,
        borderWidth: '1px 1px 1px 0px',
        borderRadius: '0 8px 8px 0',
        paddingTop: '12px',
        paddingBottom: '12px',
        paddingRight: isDesktop ? '12px': '16px',
    },
    'td': {
        border: `solid ${greyishBlue100}`,
        borderWidth: '1px 0px 1px 0px',
        paddingTop: '12px',
        paddingBottom: '12px',
        color: black500
    }
}));

function TableRow({isDesktop = false, ...props}) {
    return (
        <StyledTableRow {...props} isDesktop={isDesktop}>
            {props.children}
        </StyledTableRow>
    );
}

export default TableRow;
